import { Button, Form, FormProps } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import MailField from '@/components/form/fields/mail-field'
import BackToLoginLink from '@/components/reset-password/back-to-login-link'
import { PC_BREAKPOINT } from '@/hooks/use-breakpoint'
import { useIntl } from '@/i18n/hooks/use-intl'

export type ResetPasswordFormValues = {
  email: string
}

type ResetPasswordProps = FormProps<ResetPasswordFormValues> & {
  loading?: boolean
}

export const ResetPasswordForm: FunctionComponent<ResetPasswordProps> = ({
  form: derivedForm,
  loading,
  ...restProps
}) => {
  const { formatMessage } = useIntl()
  const [form] = Form.useForm(derivedForm)

  return (
    <Wrapper>
      <Form form={form} layout='vertical' {...restProps}>
        <MailField />
        <Footer>
          <Button
            block
            htmlType='submit'
            loading={loading}
            size='large'
            type='primary'
          >
            {formatMessage({ id: 'account:forget_submit_btn' })}
          </Button>
          <BackToLoginLinkWrapper>
            <BackToLoginLink />
          </BackToLoginLinkWrapper>
        </Footer>
      </Form>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .ant-form {
    > .ant-form-item {
      margin-bottom: 0px;
    }
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px;

  @media (max-width: ${PC_BREAKPOINT}px) {
    margin-top: 24px;
  }
`

const BackToLoginLinkWrapper = styled.div`
  display: flex;
  justify-content: center;

  a {
    text-decoration: underline;
  }
`
